<template>
    <div class="under">
        <div class="list">
            <dl>
                <dt>首页</dt>
                <dd @click="confict()" v-if="!unbind" class="small">产品介绍</dd>
                <dd v-else>产品介绍</dd>
                <dd @click="redole()" v-if="!unbind" class="small">成功案例</dd>
                <dd v-else>成功案例</dd>
            </dl>
            <dl class="about">
                <dt>关于我们</dt>
                <dd @click="company()" v-if="!isuser" class="small">公司简介</dd>
                <dd v-else>公司简介</dd>
                <dd @click="develop()" v-if="!isuser" class="small">发展历程</dd>
                <dd v-else>发展历程</dd>
                <dd @click="distri()" v-if="!isuser" class="small">分布地区</dd>
                <dd v-else>分布地区</dd>
                <dd @click="display()" v-if="!isuser" class="small">资历展示</dd>
                <dd v-else>资历展示</dd>
            </dl>
            <dl class="about">
                <dt>产品介绍</dt>
                <dd @click="Introd()" class="small">客服热线系统</dd>
                <dd @click="artif()" class="small">AI智能客服平台</dd>
                <dd @click="compreh()" class="small">综合管理平台</dd>
                <dd @click="smart()" class="small">智慧水厂管理平台</dd>
                <dd @click="Introd()" class="small">查看更多</dd>
            </dl>
            <dl class="about">
                <dt>成功案例</dt>
                <dd @click="classics()" v-if="!success" class="small">案例展示</dd>
                <dd v-else>案例展示</dd>
                <dd @click="more()" v-if="!success" class="small">典型客户</dd>
                <dd v-else>典型客户</dd>
            </dl>
            <div class="division"></div>
            <dl class="contact">
                <dt>联系我们</dt>
                <dd>电话：021-56688369</dd>
                <dd>传真：021-56688369-300</dd>
                <dd>邮箱：guowei@cpsc-sh.com</dd>
                <dd>邮编：200441</dd>
                <dd>地址：上海市宝山区长逸路188号复旦软件园9楼902-905室</dd>
            </dl>
            <div>
                <div class="companylogo">
                    <img src="../assets/guiwei-logo/公司logo.png" alt="">
                </div>
                <div class="code">
                    <img src="../assets/guiwei-logo/二维码.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<!-- 底部信息 -->
<script setup>
import { ref, watch, } from "vue"
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const unbind = ref(false)
const success = ref(false)
const isuser = ref(true)
watch(route, (newValue, oldValue) => {
    if (route.path == "/") {
        unbind.value = false
        isuser.value = true
        success.value = true
    } if (route.path == "/aboutus") {
        unbind.value = true
        isuser.value = false
        success.value = true
    } if (route.path == "/Introd") {
        unbind.value = true
        isuser.value = true
        success.value = true
    } if (route.path == "/cases") {
        unbind.value = true
        isuser.value = true
        success.value = false
    }if (route.path == "/cont") {
        unbind.value = true
        isuser.value = true
        success.value = true
    }
},{immediate:true})
function confict() {
    var pageId = document.querySelector("#right1-1")
    window.scrollTo({
        top: pageId.offsetTop - 60,
        behavior: "smooth"
    })
}
function redole() {
    var pageId = document.querySelector("#right1-2")
    window.scrollTo({
        top: pageId.offsetTop - 60,
        behavior: "smooth"
    })

}
function company() {
    var pageId = document.querySelector("#right1-3")
    window.scrollTo({
        top: pageId.offsetTop - 60,
        behavior: "smooth"
    })
}
function develop() {
    var pageId = document.querySelector("#right1-4")
    window.scrollTo({
        top: pageId.offsetTop - 60,
        behavior: "smooth"
    })
}
function distri() {
    var pageId = document.querySelector("#right1-5")
    window.scrollTo({
        top: pageId.offsetTop - 60,
        behavior: "smooth"
    })
}
function display() {
    var pageId = document.querySelector("#right1-6")
    window.scrollTo({
        top: pageId.offsetTop - 60,
        behavior: "smooth"
    })
}
function classics() {
    var pageId = document.querySelector("#classics")
    window.scrollTo({
        top: pageId.offsetTop - 160,
        behavior: "smooth"
    })
}
function more() {
    var pageId = document.querySelector("#more")
    window.scrollTo({
        top: pageId.offsetTop - 60,
        behavior: "smooth"
    })
}
//跳转产品介绍
function Introd() {
    router.replace('/Introd')
}
function artif() {
    router.replace('/Introd/artif')
}
function compreh() {
    router.replace('/Introd/compreh')
}
function smart() {
    router.replace('/Introd/smart')
}
</script>
<!-- 底部信息 -->
<style lang="scss" scoped>
.under {
    height: 404px;
    background: #252533;
    box-shadow: inset 0px 4px 3px 0px rgba(0, 0, 0, 0.25), inset 0px -2px 2px 0px rgba(255, 255, 255, 0.08);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;

    .list {
        padding: 78px 323px 0 323px;
        display: flex;
        box-sizing: border-box;

        .small {
            cursor: pointer;
        }

        .code {
            margin: 30px 0 0 -130px;

            img {
                width: 124px;
            }
        }

        .companylogo {
            margin: 0 0 0 -130px;
            img {
                width: 128px;
            }
        }

        .about {
            margin-left: 112px;
        }

        .lksd {
            margin-left: 118px;
        }

        .introduce {
            margin-left: 106px;
        }

        .system {
            margin-left: 92px;
        }

        .introduce dd {
            width: 100%;
            text-align: center;
        }

        dt {
            width: 100%;
            height: 20px;
            font-size: 16px;
            font-family: Source Sans Pro-Semibold, Source Sans Pro;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 19px;
            margin-bottom: 30px
        }

        .division {
            width: 0;
            height: 178px;
            opacity: 1;
            border: 1px solid rgba(255, 255, 255, 0.5);
            margin: 20px 0 0 83px;
        }

        .contact {
            margin-left: 87px
        }

        dd {
            width: 100%;
            height: 18px;
            font-size: 14px;
            font-family: Source Sans Pro-Regular, Source Sans Pro;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 16px;
            margin: 20px 0 0 0;
        }
    }


}
</style>